import { useState, useEffect } from 'react';
import { getRecintos } from '../../services/api';
import CalendarioCancha from './CalendarioCancha';

export default function PropuestaDesafio({ rival, onEnviar, onCancelar }) {

  const [paso,           setPaso]           = useState('recinto');
  const [recintoId,      setRecintoId]      = useState(null);
  const [canchaId,       setCanchaId]       = useState(null);
  const [duracion,       setDuracion]       = useState(1);
  const [fechaSel,       setFechaSel]       = useState(null);
  const [horaSel,        setHoraSel]        = useState(null);
  const [arbitroId,      setArbitroId]      = useState(null);
  const [conArbitro,     setConArbitro]     = useState(false);
  const [canchaExterna,  setCanchaExterna]  = useState(false);
  const [arbitroExterno, setArbitroExterno] = useState(false);
  // Padel/Tenis
  const [modalidadJuego,     setModalidadJuego]     = useState('individual');
  const [formatoSets,        setFormatoSets]        = useState('2sets_supertb');
  const [tipoPartido,        setTipoPartido]        = useState('oficial');   // oficial | amistoso
  const [busquedaCompanero,  setBusquedaCompanero]  = useState('');
  const [companeroLocal,     setCompaneroLocal]     = useState(null);
  const [resultadosBusqueda, setResultadosBusqueda] = useState([]);
  const [buscandoCompanero,  setBuscandoCompanero]  = useState(false);
  const [companeroExterno,   setCompaneroExterno]   = useState(false); // no está en TuRival
  const [nombreExterno,      setNombreExterno]      = useState('');
  const [celularExterno,     setCelularExterno]     = useState('');
  const [mensaje,        setMensaje]        = useState('');
  const [modalidad,      setModalidad]      = useState('pago_medias');

  // Recinto manual (cuando canchaExterna=true y no está en la lista)
  const [recintoManual,   setRecintoManual]   = useState(false);
  const [nombreRecinto,   setNombreRecinto]   = useState('');
  const [direccionManual, setDireccionManual] = useState('');
  const [nombreCancha,    setNombreCancha]    = useState('');

  const [recintos,         setRecintos]         = useState([]);
  const [arbitros,         setArbitros]         = useState([]);
  const [canchas,          setCanchas]          = useState([]);
  const [cargando,         setCargando]         = useState(true);
  const [cargandoArbitros, setCargandoArbitros] = useState(false);

  useEffect(() => {
    setCargando(true);
    getRecintos()
      .then(recsData => {
        if (Array.isArray(recsData)) setRecintos(recsData);
      }).catch(() => {})
      .finally(() => setCargando(false));
  }, []);

  useEffect(() => {
    if (!recintoId) { setCanchas([]); return; }
    fetch(`${process.env.REACT_APP_API_URL}/api/canchas/recinto/${recintoId}`)
      .then(r => r.json())
      .then(data => { if (Array.isArray(data)) setCanchas(data); })
      .catch(() => {});
  }, [recintoId]);

  // La cancha dirige al árbitro — se cargan cuando se elige fecha y hora
  useEffect(() => {
    if (!fechaSel || !horaSel) { setArbitros([]); return; }
    setCargandoArbitros(true);
    fetch(`${process.env.REACT_APP_API_URL}/api/arbitros/disponibles?fecha=${fechaSel}&hora=${horaSel}`)
      .then(r => r.json())
      .then(data => { if (Array.isArray(data)) setArbitros(data); })
      .catch(() => {})
      .finally(() => setCargandoArbitros(false));
  }, [fechaSel, horaSel]);

  const esFutbol   = !rival?.deporte || rival?.deporte === 'futbol';

  const recintoSel = recintos.find(r => r.id === recintoId);
  const canchaSel  = canchas.find(c => c.id === canchaId);
  const arbitroSel = arbitros.find(a => a.id === arbitroId);

  const precioCancha      = canchaExterna  ? 0 : (canchaSel?.precio || 0) * duracion;
  const precioArbitro     = arbitroExterno ? 0 : conArbitro && arbitroSel ? arbitroSel.tarifa : 0;
  const totalPartido      = precioCancha + precioArbitro;
  const depositoPorEquipo = Math.round(totalPartido / 2);

  const labelDuracion = duracion === 1 ? '1 hora' : duracion === 1.5 ? '1:30 hrs' : '2 horas';

  const buscarCompanero = async (query) => {
    setBusquedaCompanero(query);
    if (query.length < 2) { setResultadosBusqueda([]); return; }
    setBuscandoCompanero(true);
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/api/usuarios?q=${encodeURIComponent(query)}`);
      const data = await res.json();
      setResultadosBusqueda(Array.isArray(data) ? data.slice(0, 5) : []);
    } catch { setResultadosBusqueda([]); }
    finally { setBuscandoCompanero(false); }
  };

  const handleSeleccionCalendario = ({ fecha, hora }) => {
    setFechaSel(fecha);
    setHoraSel(hora);
  };

  const handleEnviar = () => {
    onEnviar({
      rival,
      recinto:        recintoManual ? null : recintoSel,
      cancha:         recintoManual ? null : canchaSel,
      duracion,
      fecha:          fechaSel,
      hora:           horaSel,
      arbitro:        null,
      conArbitro:     esFutbol ? conArbitro : false,
      canchaExterna,
      arbitroExterno,
      mensaje,
      deposito:       depositoPorEquipo,
      recintoManual,
      nombreRecinto:  recintoManual ? nombreRecinto  : null,
      direccionManual: recintoManual ? direccionManual : null,
      nombreCancha:   recintoManual ? nombreCancha   : null,
      modalidad_pago: modalidad,
      // Padel/Tenis
      modalidad_juego:      esFutbol ? 'individual' : modalidadJuego,
      companero_local_id:   (!esFutbol && modalidadJuego === 'dobles' && !companeroExterno) ? companeroLocal?.id || null : null,
      companero_externo:    (!esFutbol && modalidadJuego === 'dobles' && companeroExterno) ? { nombre: nombreExterno, celular: celularExterno } : null,
      formato_sets:         esFutbol ? null : formatoSets,
      tipo_partido:         esFutbol ? null : tipoPartido,
    });
  };

  return (
    <div style={styles.wrap}>

      {/* Header rival */}
      <div style={styles.rivalHeader}>
        <div style={{
          ...styles.crest,
          background: `linear-gradient(135deg, ${rival.colorPrincipal}, ${rival.colorSecundario})`,
        }}>
          {rival.iniciales}
        </div>
        <div>
          <div style={styles.rivalTitulo}>Desafiar a {rival.nombre}</div>
          <div style={styles.rivalMeta}>
            ELO {rival.elo} · {rival.zona} · {rival.edadPromedio} años prom.
          </div>
        </div>
      </div>

      {/* Mini stepper */}
      <div style={styles.miniStepper}>
        {[
          { id: 'recinto',    label: 'Recinto'    },
          { id: 'calendario', label: 'Fecha/Hora' },
          { id: 'arbitro',    label: esFutbol ? 'Árbitro' : 'Modalidad' },
        ].map(({ id, label }, i) => {
          const pasos     = ['recinto','calendario','arbitro'];
          const idxActual = pasos.indexOf(paso);
          const idxEste   = pasos.indexOf(id);
          const completo  = idxEste < idxActual;
          const activo    = idxEste === idxActual;
          return (
            <div key={id} style={styles.miniStepItem}>
              <div style={{
                ...styles.miniCirculo,
                background: completo ? '#16A34A' : activo ? '#FF6B1A' : '#E8ECF4',
              }}>
                <span style={{ color: completo || activo ? 'white' : '#9BA5B7', fontSize: 11, fontWeight: 700 }}>
                  {completo ? '✓' : i + 1}
                </span>
              </div>
              <span style={{
                fontSize: 10, fontWeight: 600,
                color: activo ? '#141922' : '#9BA5B7',
                fontFamily: "'Barlow', sans-serif",
                textTransform: 'uppercase', letterSpacing: '0.04em',
              }}>
                {label}
              </span>
              {i < 2 && (
                <div style={{ ...styles.miniLinea, background: completo ? '#16A34A' : '#E8ECF4' }} />
              )}
            </div>
          );
        })}
      </div>

      {/* ── PASO A: RECINTO ── */}
      {paso === 'recinto' && (
        <div>
          <div style={styles.pasoTitulo}>Elige el recinto</div>
          <div style={styles.pasoSub}>
            Selecciona dónde quieres jugar. Verás su disponibilidad en el siguiente paso.
          </div>

          <div
            style={{
              ...styles.casoEspecialBtn,
              background: canchaExterna ? '#FFF7ED' : 'white',
              border: `1.5px solid ${canchaExterna ? '#FF6B1A' : '#E8ECF4'}`,
              marginBottom: 12,
            }}
            onClick={() => setCanchaExterna(!canchaExterna)}
          >
            <div style={styles.casoEspecialCheck}>{canchaExterna ? '✓' : '○'}</div>
            <div>
              <div style={styles.casoEspecialLabel}>Cancha ya arrendada</div>
              <div style={styles.casoEspecialDesc}>Tienes cancha contratada directamente con el recinto — indica fecha, hora y lugar</div>
            </div>
          </div>

          {cargando ? (
            <div style={styles.cargando}>Cargando recintos...</div>
          ) : recintos.length === 0 ? (
            <div style={styles.sinRecintos}>No hay recintos registrados aún en TuRival.</div>
          ) : (
            <div style={styles.recintosList}>
              {/* Opción recinto manual — solo visible cuando canchaExterna=true */}
              {canchaExterna && (
                <div
                  onClick={() => { setRecintoManual(!recintoManual); setRecintoId(null); setCanchaId(null); }}
                  style={{
                    ...styles.recintoCard,
                    border: `2px solid ${recintoManual ? '#FF6B1A' : '#E8ECF4'}`,
                    background: recintoManual ? '#FFF7ED' : 'white',
                    marginBottom: 4,
                  }}
                >
                  <div style={styles.recintoInfo}>
                    <div style={{ ...styles.recintoNombre, color: recintoManual ? '#FF6B1A' : '#141922' }}>
                      🏟️ Mi recinto no está en la lista
                    </div>
                    <div style={styles.recintoDireccion}>Ingresa el nombre y dirección manualmente</div>
                  </div>
                  {recintoManual && <div style={{ ...styles.checkBadge, background: '#FF6B1A' }}>✓</div>}
                </div>
              )}

              {/* Formulario recinto manual */}
              {canchaExterna && recintoManual && (
                <div style={{ background: '#FFF7ED', border: '1.5px solid #FF6B1A', borderRadius: 12, padding: 14, marginBottom: 8 }}>
                  <div style={{ marginBottom: 10 }}>
                    <div style={styles.subLabel}>Nombre del recinto</div>
                    <input
                      value={nombreRecinto}
                      onChange={e => setNombreRecinto(e.target.value)}
                      placeholder="Ej: Estadio Municipal Machalí"
                      style={{ width: '100%', padding: '9px 12px', border: '1.5px solid #E8ECF4', borderRadius: 9, fontSize: 13, color: '#141922', fontFamily: "'Barlow', sans-serif", outline: 'none', boxSizing: 'border-box' }}
                    />
                  </div>
                  <div style={{ marginBottom: 10 }}>
                    <div style={styles.subLabel}>Dirección</div>
                    <input
                      value={direccionManual}
                      onChange={e => setDireccionManual(e.target.value)}
                      placeholder="Ej: Av. Los Deportes 1240, Machalí"
                      style={{ width: '100%', padding: '9px 12px', border: '1.5px solid #E8ECF4', borderRadius: 9, fontSize: 13, color: '#141922', fontFamily: "'Barlow', sans-serif", outline: 'none', boxSizing: 'border-box' }}
                    />
                  </div>
                  <div>
                    <div style={styles.subLabel}>Nombre de la cancha (opcional)</div>
                    <input
                      value={nombreCancha}
                      onChange={e => setNombreCancha(e.target.value)}
                      placeholder="Ej: Cancha de pasto sintético"
                      style={{ width: '100%', padding: '9px 12px', border: '1.5px solid #E8ECF4', borderRadius: 9, fontSize: 13, color: '#141922', fontFamily: "'Barlow', sans-serif", outline: 'none', boxSizing: 'border-box' }}
                    />
                  </div>
                </div>
              )}

              {/* Lista de recintos registrados */}
              {(!canchaExterna || !recintoManual) && recintos.map(r => (
                <div
                  key={r.id}
                  onClick={() => { setRecintoId(r.id); setCanchaId(null); }}
                  style={{
                    ...styles.recintoCard,
                    border: `2px solid ${recintoId === r.id ? '#1A6BFF' : '#E8ECF4'}`,
                    background: recintoId === r.id ? '#EFF5FF' : 'white',
                  }}
                >
                  <div style={styles.recintoInfo}>
                    <div style={styles.recintoNombre}>{r.nombre}</div>
                    <div style={styles.recintoDireccion}>{r.direccion}</div>
                    <div style={styles.recintoZona}>📍 {r.zona} · ★ {r.rating}</div>
                  </div>
                  {recintoId === r.id && <div style={styles.checkBadge}>✓</div>}
                </div>
              ))}
            </div>
          )}

          {recintoSel && (
            <div style={{ marginTop: 16 }}>
              <div style={styles.subLabel}>Cancha</div>
              {canchas.length === 0 ? (
                <div style={styles.sinRecintos}>Este recinto no tiene canchas registradas.</div>
              ) : (
                <div style={styles.canchasList}>
                  {canchas.map(c => (
                    <div
                      key={c.id}
                      onClick={() => setCanchaId(c.id)}
                      style={{
                        ...styles.canchaCard,
                        border: `2px solid ${canchaId === c.id ? '#1A6BFF' : '#E8ECF4'}`,
                        background: canchaId === c.id ? '#EFF5FF' : 'white',
                      }}
                    >
                      <div>
                        <div style={styles.canchaNombre}>{c.nombre}</div>
                        <div style={styles.canchaModal}>{c.tipo} · {c.superficie}</div>
                      </div>
                      <div style={styles.canchaPrecio}>
                        ${Number(c.precio).toLocaleString('es-CL')}/hr
                      </div>
                    </div>
                  ))}
                </div>
              )}

              {canchaId && (
                <div style={{ marginTop: 14 }}>
                  <div style={styles.subLabel}>Duración</div>
                  <div style={styles.duracionGrid}>
                    {[1, 1.5, 2].map(d => (
                      <div
                        key={d}
                        onClick={() => setDuracion(d)}
                        style={{
                          ...styles.duracionBtn,
                          border: `2px solid ${duracion === d ? '#1A6BFF' : '#E8ECF4'}`,
                          background: duracion === d ? '#EFF5FF' : 'white',
                        }}
                      >
                        <div style={{ ...styles.duracionLabel, color: duracion === d ? '#1A6BFF' : '#141922' }}>
                          {d === 1 ? '1 hora' : d === 1.5 ? '1:30 hrs' : '2 horas'}
                        </div>
                        <div style={{ ...styles.duracionPrecio, color: duracion === d ? '#1A6BFF' : '#9BA5B7' }}>
                          ${Number((canchaSel?.precio || 0) * d).toLocaleString('es-CL')}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          )}

          <div style={styles.botones}>
            <button style={styles.btnCancelar} onClick={onCancelar}>Cancelar</button>
            <button
              style={{ ...styles.btnSiguiente, opacity: (recintoId && canchaId) || (canchaExterna && (recintoId || (recintoManual && nombreRecinto))) ? 1 : 0.5 }}
              disabled={!((recintoId && canchaId) || (canchaExterna && (recintoId || (recintoManual && nombreRecinto))))}
              onClick={() => setPaso('calendario')}
            >
              {canchaExterna ? 'Elegir fecha y hora →' : 'Ver disponibilidad →'}
            </button>
          </div>
        </div>
      )}

      {/* ── PASO B: CALENDARIO ── */}
      {paso === 'calendario' && (
        <div>
          <div style={styles.pasoTitulo}>Elige fecha y hora</div>

          {canchaExterna ? (
            /* Flujo simplificado para cancha arrendada */
            <div>
              <div style={styles.pasoSub}>
                Indica la fecha, hora y nombre de la cancha donde jugarán.
              </div>
              <div style={{ marginBottom: 14 }}>
                <div style={styles.subLabel}>Fecha</div>
                <input
                  type="date"
                  value={fechaSel || ''}
                  onChange={e => setFechaSel(e.target.value)}
                  style={{ width: '100%', padding: '11px 14px', border: '1.5px solid #E8ECF4', borderRadius: 10, fontSize: 14, color: '#141922', fontFamily: "'Barlow', sans-serif", outline: 'none', boxSizing: 'border-box' }}
                />
              </div>
              <div style={{ marginBottom: 14 }}>
                <div style={styles.subLabel}>Hora</div>
                <select
                  value={horaSel || ''}
                  onChange={e => setHoraSel(e.target.value)}
                  style={{ width: '100%', padding: '11px 14px', border: '1.5px solid #E8ECF4', borderRadius: 10, fontSize: 14, color: '#141922', fontFamily: "'Barlow', sans-serif", outline: 'none', boxSizing: 'border-box', background: 'white' }}
                >
                  <option value="">Selecciona hora</option>
                  {['08:00','09:00','10:00','11:00','12:00','13:00','14:00','15:00',
                    '16:00','17:00','18:00','19:00','20:00','21:00','22:00'].map(h => (
                    <option key={h} value={h}>{h}</option>
                  ))}
                </select>
              </div>
              <div style={{ marginBottom: 14 }}>
                <div style={styles.subLabel}>Duración</div>
                <div style={styles.duracionGrid}>
                  {[1, 1.5, 2].map(d => (
                    <div
                      key={d}
                      onClick={() => setDuracion(d)}
                      style={{
                        ...styles.duracionBtn,
                        border: `2px solid ${duracion === d ? '#1A6BFF' : '#E8ECF4'}`,
                        background: duracion === d ? '#EFF5FF' : 'white',
                      }}
                    >
                      <div style={{ ...styles.duracionLabel, color: duracion === d ? '#1A6BFF' : '#141922' }}>
                        {d === 1 ? '1 hora' : d === 1.5 ? '1:30 hrs' : '2 horas'}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ) : (
            /* Flujo normal con calendario de disponibilidad */
            <div>
              <div style={styles.pasoSub}>
                Los días en verde tienen horarios disponibles. Haz clic en un día para ver los bloques horarios.
              </div>
              <CalendarioCancha
                cancha={canchaSel}
                recinto={recintoSel}
                duracion={duracion}
                onSeleccion={handleSeleccionCalendario}
              />
            </div>
          )}

          <div style={styles.botones}>
            <button
              style={styles.btnCancelar}
              onClick={() => { setPaso('recinto'); setFechaSel(null); setHoraSel(null); }}
            >
              ← Atrás
            </button>
            <button
              style={{ ...styles.btnSiguiente, opacity: fechaSel && horaSel ? 1 : 0.5 }}
              disabled={!fechaSel || !horaSel}
              onClick={() => setPaso('arbitro')}
            >
              {esFutbol ? 'Elegir árbitro →' : 'Modalidad →'}
            </button>
          </div>
        </div>
      )}

      {/* ── PASO C: ÁRBITRO / MODALIDAD ── */}
      {paso === 'arbitro' && (
        <div>
          <div style={styles.pasoTitulo}>
            {esFutbol ? '¿Quieres árbitro?' : '¿Cómo juegas?'}
          </div>
          <div style={styles.pasoSub}>
            {esFutbol
              ? 'Un árbitro profesional garantiza un partido más ordenado y justo.'
              : 'Indica si juegas individual o dobles, y agrega tu compañero si aplica.'}
          </div>

          {/* Selector modalidad juego para padel/tenis */}
          {!esFutbol && (
            <div style={{ marginBottom: 20 }}>
              <div style={styles.subLabel}>Modalidad</div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8, marginBottom: 16 }}>
                {[
                  { id: 'individual', label: '🏃 Individual', desc: '1 vs 1' },
                  { id: 'dobles',     label: '👥 Dobles',     desc: '2 vs 2' },
                ].map(m => (
                  <div
                    key={m.id}
                    onClick={() => { setModalidadJuego(m.id); setCompaneroLocal(null); setBusquedaCompanero(''); }}
                    style={{
                      borderRadius: 12, padding: '14px', cursor: 'pointer', textAlign: 'center',
                      border: `2px solid ${modalidadJuego === m.id ? '#FF6B1A' : '#E8ECF4'}`,
                      background: modalidadJuego === m.id ? '#FFF7ED' : 'white',
                    }}
                  >
                    <div style={{ fontFamily: "'Barlow Condensed', sans-serif", fontSize: 16, fontWeight: 700, color: modalidadJuego === m.id ? '#FF6B1A' : '#141922', marginBottom: 3 }}>
                      {m.label}
                    </div>
                    <div style={{ fontSize: 11, color: '#9BA5B7', fontFamily: "'Barlow', sans-serif" }}>{m.desc}</div>
                  </div>
                ))}
              </div>

              {/* Buscador compañero para dobles */}
              {modalidadJuego === 'dobles' && (
                <div>
                  <div style={styles.subLabel}>Tu compañero</div>

                  {/* Toggle: en TuRival / no está */}
                  {!companeroLocal && !companeroExterno && (
                    <div style={{ display: 'flex', gap: 8, marginBottom: 10 }}>
                      <button
                        onClick={() => { setCompaneroExterno(false); setNombreExterno(''); setCelularExterno(''); }}
                        style={{ flex: 1, padding: '8px', borderRadius: 8, cursor: 'pointer',
                          fontFamily: "'Barlow Condensed', sans-serif", fontSize: 13, fontWeight: 700,
                          background: !companeroExterno ? '#0D1117' : '#F4F6FA',
                          color: !companeroExterno ? 'white' : '#6B7280',
                          border: !companeroExterno ? 'none' : '1.5px solid #E8ECF4' }}
                      >
                        Buscar en TuRival
                      </button>
                      <button
                        onClick={() => { setCompaneroExterno(true); setCompaneroLocal(null); setBusquedaCompanero(''); }}
                        style={{ flex: 1, padding: '8px', borderRadius: 8, cursor: 'pointer',
                          fontFamily: "'Barlow Condensed', sans-serif", fontSize: 13, fontWeight: 700,
                          background: companeroExterno ? '#FF6B1A' : '#F4F6FA',
                          color: companeroExterno ? 'white' : '#6B7280',
                          border: companeroExterno ? 'none' : '1.5px solid #E8ECF4' }}
                      >
                        No está en TuRival
                      </button>
                    </div>
                  )}

                  {/* Compañero registrado seleccionado */}
                  {companeroLocal && !companeroExterno && (
                    <div style={{ display: 'flex', alignItems: 'center', gap: 10, background: '#F0FDF4', border: '1px solid #86EFAC', borderRadius: 10, padding: '10px 14px', marginBottom: 8 }}>
                      <div style={{ flex: 1, fontSize: 14, fontWeight: 600, color: '#141922', fontFamily: "'Barlow', sans-serif" }}>
                        ✓ {companeroLocal.nombre}
                      </div>
                      <button
                        onClick={() => { setCompaneroLocal(null); setBusquedaCompanero(''); }}
                        style={{ background: 'transparent', border: 'none', color: '#EF4444', cursor: 'pointer', fontSize: 13, fontWeight: 700 }}
                      >
                        Cambiar
                      </button>
                    </div>
                  )}

                  {/* Buscador en TuRival */}
                  {!companeroExterno && !companeroLocal && (
                    <div style={{ position: 'relative', marginBottom: 8 }}>
                      <input
                        value={busquedaCompanero}
                        onChange={e => buscarCompanero(e.target.value)}
                        placeholder="Buscar por nombre..."
                        style={{ width: '100%', padding: '11px 14px', border: '1.5px solid #E8ECF4', borderRadius: 10, fontSize: 14, color: '#141922', fontFamily: "'Barlow', sans-serif", outline: 'none', boxSizing: 'border-box' }}
                      />
                      {buscandoCompanero && (
                        <div style={{ position: 'absolute', right: 12, top: '50%', transform: 'translateY(-50%)', fontSize: 12, color: '#9BA5B7' }}>Buscando...</div>
                      )}
                      {resultadosBusqueda.length > 0 && (
                        <div style={{ position: 'absolute', top: '100%', left: 0, right: 0, background: 'white', border: '1.5px solid #E8ECF4', borderRadius: 10, boxShadow: '0 4px 12px rgba(0,0,0,0.08)', zIndex: 10, marginTop: 4 }}>
                          {resultadosBusqueda.map(u => (
                            <div
                              key={u.id}
                              onClick={() => { setCompaneroLocal(u); setResultadosBusqueda([]); setBusquedaCompanero(''); }}
                              style={{ padding: '10px 14px', cursor: 'pointer', fontSize: 13, fontWeight: 600, color: '#141922', fontFamily: "'Barlow', sans-serif", borderBottom: '1px solid #F4F6FA' }}
                            >
                              {u.nombre}
                              {u.email && <span style={{ fontSize: 11, color: '#9BA5B7', marginLeft: 6 }}>{u.email}</span>}
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  )}

                  {/* Formulario compañero externo */}
                  {companeroExterno && (
                    <div style={{ background: '#FFF7ED', border: '1.5px solid #FF6B1A', borderRadius: 12, padding: 14, marginBottom: 8 }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
                        <div style={{ fontSize: 12, fontWeight: 700, color: '#FF6B1A', fontFamily: "'Barlow', sans-serif" }}>
                          📨 Le enviaremos invitación por WhatsApp
                        </div>
                        <button
                          onClick={() => { setCompaneroExterno(false); setNombreExterno(''); setCelularExterno(''); }}
                          style={{ background: 'transparent', border: 'none', color: '#9BA5B7', cursor: 'pointer', fontSize: 12 }}
                        >
                          Cancelar
                        </button>
                      </div>
                      <div style={{ marginBottom: 8 }}>
                        <div style={styles.subLabel}>Nombre</div>
                        <input
                          value={nombreExterno}
                          onChange={e => setNombreExterno(e.target.value)}
                          placeholder="Nombre del compañero"
                          style={{ width: '100%', padding: '9px 12px', border: '1.5px solid #E8ECF4', borderRadius: 9, fontSize: 13, color: '#141922', fontFamily: "'Barlow', sans-serif", outline: 'none', boxSizing: 'border-box' }}
                        />
                      </div>
                      <div>
                        <div style={styles.subLabel}>Celular (WhatsApp)</div>
                        <input
                          value={celularExterno}
                          onChange={e => setCelularExterno(e.target.value)}
                          placeholder="+56912345678"
                          style={{ width: '100%', padding: '9px 12px', border: '1.5px solid #E8ECF4', borderRadius: 9, fontSize: 13, color: '#141922', fontFamily: "'Barlow', sans-serif", outline: 'none', boxSizing: 'border-box' }}
                        />
                      </div>
                      {nombreExterno && celularExterno && (
                        <div style={{ marginTop: 10, fontSize: 11, color: '#FF6B1A', fontFamily: "'Barlow', sans-serif" }}>
                          ✓ Se enviará invitación a {nombreExterno} al confirmar el desafío
                        </div>
                      )}
                    </div>
                  )}
                </div>
              )}

              {/* Formato partido para padel/tenis */}
              <div style={{ marginTop: 16 }}>
                <div style={styles.subLabel}>Formato</div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: 6, marginBottom: 12 }}>
                  {[
                    { id: '2sets_supertb',        label: '2 Sets + Súper Tie Break' },
                    { id: '2sets_puntoro',         label: '2 Sets + Punto de Oro' },
                    { id: '2sets_puntoro_supertb', label: '2 Sets + Punto de Oro + Súper Tie Break' },
                  ].map(f => (
                    <div key={f.id} onClick={() => setFormatoSets(f.id)}
                      style={{ borderRadius: 10, padding: '10px 14px', cursor: 'pointer',
                        display: 'flex', alignItems: 'center', gap: 10,
                        border: `2px solid ${formatoSets === f.id ? '#1A6BFF' : '#E8ECF4'}`,
                        background: formatoSets === f.id ? '#EFF5FF' : 'white' }}>
                      <div style={{ width: 16, height: 16, borderRadius: '50%', flexShrink: 0,
                        border: `2px solid ${formatoSets === f.id ? '#1A6BFF' : '#E8ECF4'}`,
                        background: formatoSets === f.id ? '#1A6BFF' : 'white',
                        display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        {formatoSets === f.id && <div style={{ width: 5, height: 5, borderRadius: '50%', background: 'white' }} />}
                      </div>
                      <div style={{ fontFamily: "'Barlow', sans-serif", fontSize: 13, fontWeight: 600, color: formatoSets === f.id ? '#1A6BFF' : '#141922' }}>{f.label}</div>
                    </div>
                  ))}
                </div>

                <div style={styles.subLabel}>Tipo de partido</div>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
                  {[
                    { id: 'oficial', label: '🏆 Oficial', desc: 'Afecta el ELO' },
                    { id: 'amistoso', label: '🤝 Amistoso', desc: 'Sin cambio de ELO' },
                  ].map(f => (
                    <div key={f.id} onClick={() => setTipoPartido(f.id)}
                      style={{ borderRadius: 10, padding: '10px 8px', cursor: 'pointer', textAlign: 'center',
                        border: `2px solid ${tipoPartido === f.id ? '#FF6B1A' : '#E8ECF4'}`,
                        background: tipoPartido === f.id ? '#FFF7ED' : 'white' }}>
                      <div style={{ fontFamily: "'Barlow Condensed', sans-serif", fontSize: 14, fontWeight: 700, color: tipoPartido === f.id ? '#FF6B1A' : '#141922', marginBottom: 2 }}>{f.label}</div>
                      <div style={{ fontSize: 10, color: '#9BA5B7', fontFamily: "'Barlow', sans-serif" }}>{f.desc}</div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}

          {esFutbol && <div
            style={{
              ...styles.casoEspecialBtn,
              background: arbitroExterno ? '#FFF7ED' : 'white',
              border: `1.5px solid ${arbitroExterno ? '#FF6B1A' : '#E8ECF4'}`,
              marginBottom: 14,
            }}
            onClick={() => { setArbitroExterno(!arbitroExterno); setConArbitro(false); setArbitroId(null); }}
          >
            <div style={styles.casoEspecialCheck}>{arbitroExterno ? '✓' : '○'}</div>
            <div>
              <div style={styles.casoEspecialLabel}>Ya tengo árbitro contratado directamente</div>
              <div style={styles.casoEspecialDesc}>TuRival coordina el desafío sin intermediar el pago del árbitro</div>
            </div>
          </div>}

          {esFutbol && !arbitroExterno && (
            <>
              <div style={styles.arbitroToggleWrap}>
                <button
                  style={{
                    ...styles.arbitroToggleBtn,
                    background: !conArbitro ? '#0D1117' : '#F4F6FA',
                    color:      !conArbitro ? 'white'   : '#6B7280',
                    border:     !conArbitro ? 'none'    : '1.5px solid #E8ECF4',
                  }}
                  onClick={() => { setConArbitro(false); setArbitroId(null); }}
                >
                  Sin árbitro
                </button>
                <button
                  style={{
                    ...styles.arbitroToggleBtn,
                    background: conArbitro ? '#FF6B1A' : '#F4F6FA',
                    color:      conArbitro ? 'white'   : '#6B7280',
                    border:     conArbitro ? 'none'    : '1.5px solid #E8ECF4',
                  }}
                  onClick={() => setConArbitro(true)}
                >
                  Con árbitro
                </button>
              </div>

              {conArbitro && (
                <>
                  <div style={{ background: '#F0FDF4', border: '1px solid #86EFAC', borderRadius: 10, padding: '10px 14px', marginBottom: 12, fontSize: 12, color: '#16A34A', fontFamily: "'Barlow', sans-serif" }}>
                    🗓️ Mostrando árbitros disponibles para <strong>{fechaSel} · {horaSel}</strong>
                  </div>

                  {cargandoArbitros ? (
                    <div style={styles.sinArbitros}>Buscando árbitros disponibles...</div>
                  ) : arbitros.length === 0 ? (
                    <div style={{ background: '#FEF2F2', border: '1px solid #FCA5A5', borderRadius: 12, padding: '16px', marginBottom: 16, textAlign: 'center' }}>
                      <div style={{ fontSize: 24, marginBottom: 8 }}>😔</div>
                      <div style={{ fontFamily: "'Barlow Condensed', sans-serif", fontSize: 16, fontWeight: 800, color: '#EF4444', marginBottom: 6 }}>
                        Sin árbitros disponibles para este horario
                      </div>
                      <div style={{ fontSize: 12, color: '#6B7280', fontFamily: "'Barlow', sans-serif", marginBottom: 14, lineHeight: 1.5 }}>
                        Ningún árbitro tiene disponibilidad para el {fechaSel} a las {horaSel}.
                        Puedes volver atrás y elegir otro horario, o continuar sin árbitro.
                      </div>
                      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
                        <button
                          style={{ padding: '10px', background: 'white', border: '1.5px solid #E8ECF4', borderRadius: 10, fontFamily: "'Barlow Condensed', sans-serif", fontSize: 14, fontWeight: 700, color: '#6B7280', cursor: 'pointer' }}
                          onClick={() => { setPaso('calendario'); setFechaSel(null); setHoraSel(null); setArbitroId(null); }}
                        >
                          ← Cambiar horario
                        </button>
                        <button
                          style={{ padding: '10px', background: '#0D1117', border: 'none', borderRadius: 10, fontFamily: "'Barlow Condensed', sans-serif", fontSize: 14, fontWeight: 700, color: 'white', cursor: 'pointer' }}
                          onClick={() => { setConArbitro(false); setArbitroId(null); }}
                        >
                          Continuar sin árbitro
                        </button>
                      </div>
                    </div>
                  ) : (
                    <div style={styles.arbitrosList}>
                      {arbitros.map(a => (
                        <div
                          key={a.id}
                          onClick={() => setArbitroId(a.id)}
                          style={{
                            ...styles.arbitroCard,
                            border: `2px solid ${arbitroId === a.id ? '#FF6B1A' : '#E8ECF4'}`,
                            background: arbitroId === a.id ? '#FFF7ED' : 'white',
                          }}
                        >
                          <div style={styles.arbitroCrest}>
                            {a.nombre.split(' ').map(p => p[0]).slice(0,2).join('')}
                          </div>
                          <div style={styles.arbitroInfo}>
                            <div style={styles.arbitroNombre}>{a.nombre}</div>
                            <div style={styles.arbitroMeta}>
                              {a.experiencia} años exp. · ★ {a.rating}
                            </div>
                            <div style={styles.arbitroEspecialidad}>
                              {a.certificado ? '✓ Certificado' : 'Sin certificación'}
                              {a.federado ? ' · ✓ Federado' : ''}
                            </div>
                          </div>
                          <div style={styles.arbitroTarifa}>
                            ${Number(a.tarifa).toLocaleString('es-CL')}
                          </div>
                          {arbitroId === a.id && <div style={styles.checkBadge}>✓</div>}
                        </div>
                      ))}
                    </div>
                  )}
                </>
              )}
            </>
          )}

          {/* Mensaje */}
          <div style={{ marginBottom: 16 }}>
            <div style={styles.subLabel}>Mensaje para el rival (opcional)</div>
            <textarea
              value={mensaje}
              onChange={e => setMensaje(e.target.value)}
              placeholder="Ej: Jugamos en cancha techada, traigan pecheras..."
              style={styles.textarea}
              maxLength={200}
            />
            <span style={styles.charCount}>{mensaje.length}/200</span>
          </div>

          {/* Resumen */}

          {/* Selector modalidad de pago */}
          <div style={{ marginBottom: 16 }}>
            <div style={styles.subLabel}>Modalidad de pago</div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
              {[
                { id: 'pago_medias', label: '🤝 Pago a Medias',  desc: 'Cada equipo paga la mitad' },
                { id: 'pierde_paga', label: '🏆 Pierde Paga',    desc: 'El equipo que pierde paga todo' },
                { id: 'invitacion',  label: '🎁 Invitación',     desc: 'El equipo que desafía paga todo' },
              ].map(m => (
                <div
                  key={m.id}
                  onClick={() => setModalidad(m.id)}
                  style={{
                    display: 'flex', alignItems: 'center', gap: 12,
                    padding: '10px 14px', borderRadius: 10, cursor: 'pointer',
                    border: `1.5px solid ${modalidad === m.id ? '#FF6B1A' : '#E8ECF4'}`,
                    background: modalidad === m.id ? '#FFF7ED' : 'white',
                    transition: 'all 0.12s',
                  }}
                >
                  <div style={{
                    width: 18, height: 18, borderRadius: '50%', flexShrink: 0,
                    border: `2px solid ${modalidad === m.id ? '#FF6B1A' : '#E8ECF4'}`,
                    background: modalidad === m.id ? '#FF6B1A' : 'white',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                  }}>
                    {modalidad === m.id && <div style={{ width: 6, height: 6, borderRadius: '50%', background: 'white' }} />}
                  </div>
                  <div>
                    <div style={{ fontSize: 13, fontWeight: 600, color: '#141922', fontFamily: "'Barlow', sans-serif" }}>{m.label}</div>
                    <div style={{ fontSize: 11, color: '#9BA5B7', fontFamily: "'Barlow', sans-serif" }}>{m.desc}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div style={styles.resumenFinal}>
            <div style={styles.resumenTitle}>Resumen del desafío</div>
            <div style={styles.resumenRow}>
              <span>Rival</span>
              <span>{rival.nombre}</span>
            </div>
            {!canchaExterna && recintoSel && (
              <div style={styles.resumenRow}>
                <span>Recinto</span>
                <span>{recintoSel.nombre}</span>
              </div>
            )}
            {canchaExterna && (recintoManual ? nombreRecinto : recintoSel?.nombre) && (
              <div style={styles.resumenRow}>
                <span>Recinto</span>
                <span>{recintoManual ? nombreRecinto : recintoSel?.nombre}</span>
              </div>
            )}
            {canchaExterna && (recintoManual ? direccionManual : null) && (
              <div style={styles.resumenRow}>
                <span>Dirección</span>
                <span>{direccionManual}</span>
              </div>
            )}
            {canchaExterna && nombreCancha && (
              <div style={styles.resumenRow}>
                <span>Cancha</span>
                <span>{nombreCancha}</span>
              </div>
            )}
            {fechaSel && (
              <div style={styles.resumenRow}>
                <span>Fecha y hora</span>
                <span>{fechaSel} · {horaSel}</span>
              </div>
            )}
            {conArbitro && arbitroSel && (
              <div style={styles.resumenRow}>
                <span>Árbitro</span>
                <span>{arbitroSel.nombre}</span>
              </div>
            )}
            {!canchaExterna && (
              <div style={{ ...styles.resumenRow, ...styles.resumenTotal }}>
                <span>Depósito por equipo</span>
                <span>${depositoPorEquipo.toLocaleString('es-CL')}</span>
              </div>
            )}
            {!esFutbol && (
              <div style={styles.resumenRow}>
                <span>Modalidad juego</span>
                <span>{modalidadJuego === 'individual' ? '🏃 Individual' : '👥 Dobles'}</span>
              </div>
            )}
            {!esFutbol && (
              <div style={styles.resumenRow}>
                <span>Formato</span>
                <span>{{'2sets_supertb': '2 Sets + Súper TB', '2sets_puntoro': '2 Sets + Punto de Oro', '2sets_puntoro_supertb': '2 Sets + Punto de Oro + Súper TB'}[formatoSets]}</span>
              </div>
            )}
            {!esFutbol && (
              <div style={styles.resumenRow}>
                <span>Tipo</span>
                <span>{tipoPartido === 'oficial' ? '🏆 Oficial' : '🤝 Amistoso'}</span>
              </div>
            )}
            {!esFutbol && modalidadJuego === 'dobles' && companeroLocal && (
              <div style={styles.resumenRow}>
                <span>Compañero</span>
                <span>{companeroLocal.nombre}</span>
              </div>
            )}
            {!esFutbol && modalidadJuego === 'dobles' && companeroExterno && nombreExterno && (
              <div style={styles.resumenRow}>
                <span>Compañero</span>
                <span>📨 {nombreExterno} (se invitará)</span>
              </div>
            )}
            <div style={styles.resumenRow}>
              <span>Modalidad</span>
              <span>{{
                pago_medias: '🤝 Pago a Medias',
                pierde_paga: '🏆 Pierde Paga',
                invitacion:  '🎁 Invitación',
              }[modalidad]}</span>
            </div>
            <div style={styles.resumenNota}>
              El depósito se acuerda entre los equipos al confirmar el desafío. Los servicios adicionales se pagan al finalizar el partido.
            </div>
          </div>

          <div style={styles.botones}>
            <button style={styles.btnCancelar} onClick={() => setPaso('calendario')}>← Atrás</button>
            <button style={styles.btnEnviar} onClick={handleEnviar}>
              ⚡ Enviar desafío
            </button>
          </div>
        </div>
      )}

    </div>
  );
}

const styles = {
  wrap: { width: '100%' },
  rivalHeader: {
    display: 'flex', alignItems: 'center', gap: 12,
    background: '#0D1117', borderRadius: 12, padding: '12px 16px', marginBottom: 20,
  },
  crest: {
    width: 44, height: 44, borderRadius: 10, flexShrink: 0,
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    fontFamily: "'Barlow Condensed', sans-serif", fontSize: 14, fontWeight: 800, color: 'white',
  },
  rivalTitulo: {
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 18, fontWeight: 800, color: 'white', marginBottom: 2,
  },
  rivalMeta: { fontSize: 12, color: 'rgba(255,255,255,0.4)', fontFamily: "'Barlow', sans-serif" },
  miniStepper: {
    display: 'flex', alignItems: 'flex-start', justifyContent: 'center',
    marginBottom: 24, padding: '0 20px',
  },
  miniStepItem: {
    display: 'flex', flexDirection: 'column', alignItems: 'center',
    gap: 5, position: 'relative', flex: 1,
  },
  miniCirculo: {
    width: 28, height: 28, borderRadius: '50%',
    display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1,
  },
  miniLinea: { position: 'absolute', top: 14, left: '50%', width: '100%', height: 2, zIndex: 0 },
  pasoTitulo: {
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 24, fontWeight: 800, color: '#141922', marginBottom: 4,
  },
  pasoSub: {
    fontSize: 13, color: '#6B7280', fontFamily: "'Barlow', sans-serif",
    marginBottom: 18, lineHeight: 1.5,
  },
  casoEspecialBtn: {
    display: 'flex', alignItems: 'flex-start', gap: 12,
    borderRadius: 10, padding: '10px 14px', cursor: 'pointer', transition: 'all 0.12s',
  },
  casoEspecialCheck: { fontSize: 16, color: '#FF6B1A', fontWeight: 700, flexShrink: 0, marginTop: 1 },
  casoEspecialLabel: { fontSize: 13, fontWeight: 600, color: '#141922', fontFamily: "'Barlow', sans-serif", marginBottom: 2 },
  casoEspecialDesc: { fontSize: 11, color: '#9BA5B7', fontFamily: "'Barlow', sans-serif" },
  recintosList: { display: 'flex', flexDirection: 'column', gap: 10 },
  recintoCard: { borderRadius: 12, padding: '14px 16px', cursor: 'pointer', transition: 'all 0.12s', position: 'relative' },
  recintoInfo: {},
  recintoNombre: { fontFamily: "'Barlow Condensed', sans-serif", fontSize: 16, fontWeight: 700, color: '#141922', marginBottom: 2 },
  recintoDireccion: { fontSize: 12, color: '#6B7280', fontFamily: "'Barlow', sans-serif", marginBottom: 4 },
  recintoZona: { fontSize: 12, color: '#9BA5B7', fontFamily: "'Barlow', sans-serif" },
  checkBadge: {
    position: 'absolute', top: 12, right: 12,
    background: '#1A6BFF', color: 'white', width: 22, height: 22,
    borderRadius: '50%', display: 'flex', alignItems: 'center',
    justifyContent: 'center', fontSize: 11, fontWeight: 700,
  },
  subLabel: {
    fontSize: 11, fontWeight: 700, color: '#6B7280',
    textTransform: 'uppercase', letterSpacing: '0.05em',
    marginBottom: 8, fontFamily: "'Barlow', sans-serif",
  },
  canchasList: { display: 'flex', flexDirection: 'column', gap: 8 },
  canchaCard: {
    display: 'flex', justifyContent: 'space-between', alignItems: 'center',
    padding: '10px 14px', borderRadius: 10, cursor: 'pointer', transition: 'all 0.12s',
  },
  canchaNombre: { fontSize: 13, fontWeight: 600, color: '#141922', fontFamily: "'Barlow', sans-serif" },
  canchaModal: { fontSize: 11, color: '#9BA5B7', fontFamily: "'Barlow', sans-serif" },
  canchaPrecio: { fontFamily: "'Barlow Condensed', sans-serif", fontSize: 16, fontWeight: 700, color: '#1A6BFF' },
  duracionGrid: { display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 8, marginBottom: 4 },
  duracionBtn: { borderRadius: 10, padding: '10px 8px', textAlign: 'center', cursor: 'pointer', transition: 'all 0.12s' },
  duracionLabel: { fontFamily: "'Barlow Condensed', sans-serif", fontSize: 15, fontWeight: 700, marginBottom: 3 },
  duracionPrecio: { fontSize: 11, fontFamily: "'Barlow', sans-serif" },
  cargando: { fontSize: 13, color: '#9BA5B7', fontFamily: "'Barlow', sans-serif", textAlign: 'center', padding: '20px' },
  sinRecintos: { fontSize: 13, color: '#9BA5B7', fontFamily: "'Barlow', sans-serif", textAlign: 'center', padding: '20px', background: '#F4F6FA', borderRadius: 10 },
  arbitroToggleWrap: { display: 'flex', gap: 8, marginBottom: 16 },
  arbitroToggleBtn: { flex: 1, padding: '10px', borderRadius: 10, cursor: 'pointer', fontFamily: "'Barlow Condensed', sans-serif", fontSize: 15, fontWeight: 700, transition: 'all 0.12s' },
  arbitrosList: { display: 'flex', flexDirection: 'column', gap: 10, marginBottom: 16 },
  arbitroCard: { display: 'flex', alignItems: 'center', gap: 12, borderRadius: 12, padding: '12px 14px', cursor: 'pointer', transition: 'all 0.12s', position: 'relative' },
  arbitroCrest: { width: 40, height: 40, borderRadius: 10, background: '#0D1117', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: "'Barlow Condensed', sans-serif", fontSize: 13, fontWeight: 800, color: 'white', flexShrink: 0 },
  arbitroInfo: { flex: 1 },
  arbitroNombre: { fontFamily: "'Barlow Condensed', sans-serif", fontSize: 15, fontWeight: 700, color: '#141922', marginBottom: 2 },
  arbitroMeta: { fontSize: 11, color: '#6B7280', fontFamily: "'Barlow', sans-serif", marginBottom: 2 },
  arbitroEspecialidad: { fontSize: 10, color: '#9BA5B7', fontFamily: "'Barlow', sans-serif" },
  arbitroTarifa: { fontFamily: "'Barlow Condensed', sans-serif", fontSize: 17, fontWeight: 800, color: '#FF6B1A', flexShrink: 0 },
  sinArbitros: { padding: '20px', textAlign: 'center', color: '#9BA5B7', fontSize: 13, fontFamily: "'Barlow', sans-serif", background: '#F4F6FA', borderRadius: 12, marginBottom: 16 },
  textarea: { width: '100%', padding: '10px 12px', border: '1.5px solid #E8ECF4', borderRadius: 10, fontSize: 13, color: '#141922', fontFamily: "'Barlow', sans-serif", outline: 'none', resize: 'none', height: 80, boxSizing: 'border-box' },
  charCount: { fontSize: 11, color: '#9BA5B7', fontFamily: "'Barlow', sans-serif", float: 'right', marginTop: 3 },
  resumenFinal: { background: '#F4F6FA', borderRadius: 12, padding: '14px 16px', marginBottom: 8 },
  resumenTitle: { fontFamily: "'Barlow Condensed', sans-serif", fontSize: 13, fontWeight: 700, color: '#6B7280', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: 10 },
  resumenRow: { display: 'flex', justifyContent: 'space-between', fontSize: 13, color: '#4A5568', fontFamily: "'Barlow', sans-serif", padding: '3px 0' },
  resumenTotal: { fontWeight: 700, color: '#141922', borderTop: '1px solid #E8ECF4', marginTop: 6, paddingTop: 8, fontSize: 14 },
  resumenNota: { fontSize: 11, color: '#9BA5B7', fontFamily: "'Barlow', sans-serif", marginTop: 8, fontStyle: 'italic', lineHeight: 1.5 },
  botones: { display: 'grid', gridTemplateColumns: '1fr 2fr', gap: 10, marginTop: 16 },
  btnCancelar: { padding: '12px', background: 'white', border: '1.5px solid #E8ECF4', borderRadius: 12, fontSize: 14, fontWeight: 700, color: '#6B7280', cursor: 'pointer', fontFamily: "'Barlow Condensed', sans-serif" },
  btnSiguiente: { padding: '12px', background: '#1A6BFF', border: 'none', borderRadius: 12, fontFamily: "'Barlow Condensed', sans-serif", fontSize: 16, fontWeight: 800, color: 'white', cursor: 'pointer' },
  btnEnviar: { padding: '12px', background: '#FF6B1A', border: 'none', borderRadius: 12, fontFamily: "'Barlow Condensed', sans-serif", fontSize: 16, fontWeight: 800, color: 'white', cursor: 'pointer' },
};